import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { useApp } from "../../context/AppContext";
import adminApi from "../../lib/adminApi";
import { ADMIN } from "../../lib/adminI18n";
import { Loader2, TrendingUp } from "lucide-react";

export default function StatsTab() {
  const { lang } = useApp();
  const a = ADMIN[lang];
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try { setStats(await adminApi.stats()); }
      catch { toast.error(a.error); }
      finally { setLoading(false); }
    })();
  }, [a.error]);

  if (loading) return <div className="grid place-items-center py-16 text-muted-foreground"><Loader2 className="h-7 w-7 animate-spin" /></div>;
  if (!stats) return <div className="text-center py-16 text-muted-foreground">{a.error}</div>;

  const entries = Object.entries(stats).filter(([, v]) => typeof v === "number" || typeof v === "string");

  return (
    <div data-testid="admin-stats" className="grid gap-4 grid-cols-2 lg:grid-cols-4">
      {entries.map(([k, v]) => (
        <div key={k} className="rounded-2xl border border-border bg-card p-5">
          <div className="h-9 w-9 rounded-xl bg-primary/10 text-primary grid place-items-center mb-3"><TrendingUp className="h-5 w-5" /></div>
          <div className="text-2xl font-head font-extrabold">{v}</div>
          <div className="text-xs text-muted-foreground mt-1 capitalize">{k.replace(/_/g, " ")}</div>
        </div>
      ))}
    </div>
  );
}
